<template>
  <v-card>
    <v-form>
      <v-card-title>
        <span class="headline">Edit User Merchant</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Username </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-text-field
                    id="userEmail"
                    ref="userEmail"
                    v-model="editedItemData.userEmail"
                    @change="$v.editedItemData.userEmail.$touch()"
                    @blur="$v.editedItemData.userEmail.$touch()"
                    :error-messages="userEmailErrors"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-switch
                    v-model="changePassword"
                    label="ubah username tanpa mengubah password saat ini"
                    color="orange"
                    hide-details
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> MID </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ editedItem.merchantId }}
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Last Login </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ editedItem.lastLogin }}
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Created Date </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ editedItem.createdAt }}
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> Force Change Password </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ editedItem.forceChangePassword }}
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
        <v-btn
          color="blue darken-1"
          text
          :loading="loading"
          :disabled="loading"
          @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { date, showAlert } from '../../lib/helpers';

export default {
  props: ['editedItem', 'editedIndex'],
  mixins: [validationMixin],
  validations: {
    editedItemData: {
      userEmail: {
        required,
        email,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.username == null ||
              this.errorValidation.username.length < 1)
          );
        },
      },
    },
  },
  computed: {
    editedItemData: {
      get() {
        return this.editedItem;
      },
      set(newValue) {
        this.$emit('update:editedItem', newValue);
      },
    },
    loading() {
      return this.$store.state.userMerchant.loading;
    },
    errorValidation() {
      return this.$store.state.userMerchant.errors;
    },
    userEmailErrors() {
      const errors = [];
      if (!this.$v.editedItemData.userEmail.$dirty) return errors;
      if (!this.$v.editedItemData.userEmail.email)
        errors.push('Must be valid e-mail');
      if (!this.$v.editedItemData.userEmail.required)
        errors.push('E-mail is required');
      if (!this.$v.editedItemData.userEmail.isUnique) {
        if (
          this.errorValidation != null &&
          this.errorValidation.username != null
        ) {
          this.errorValidation.username.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
  },
  watch: {
    'editedItemData.userEmail': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.username != null &&
            val != this.errorValidation.username
          ) {
            this.$store.commit('userMerchant/clearErrorVariable', 'username');
          }
        }
      },
    },
  },
  data: () => ({
    changePassword: 1,
  }),
  methods: {
    close() {
      this.$emit('closeParent');
    },

    resetUniqueValidation() {
      this.$store.commit('userMerchant/clearErrors');
    },
    async save() {
      this.$store.commit('userMerchant/setFlashErrorMessage', '');
      this.resetUniqueValidation();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const user = {
          ...this.editedItem,
          username: this.editedItemData.userEmail,
        };

        await this.$store
          .dispatch('userMerchant/updateUser', {
            date,
            user,
            change_password: !this.changePassword,
            index: this.editedIndex,
          })
          .then((status) => {
            if (status) {
              this.close();
              showAlert(
                this.$store,
                'Update user success !',
                'mdi-check-circle',
                'green'
              );
              this.$emit('getDataParent');
            } else {
              showAlert(
                this.$store,
                'Error on update user !',
                'mdi-alert',
                'red'
              );
            }
          });
      }
    },
  },
};
</script>
